import Async from "components/DesignSystem/AsyncComponents/Async";
import { ACCOUNT_CONNECTION_TYPE } from "constants/dataSource";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useDataSourceSegregate } from "hooks/useDataSourceSegregate";
import { useGetEntityBanksQuery } from "store/apis/bankConnections";
import {
  AccountBanner,
  AccountCardsSection,
  TabEmptyState,
} from "../DataSourcesList";
import { BankConnections } from "../DataSourceView/BankConnections";

export const BankAndCreditCard = ({
  groupId,
  onMigrationSuccess,
  onOpenConnectionModal,
  onOpenSubscriptionModal,
}: {
  groupId: string;
  onMigrationSuccess: () => void;
  onOpenConnectionModal: () => void;
  onOpenSubscriptionModal: () => void;
}) => {
  const entityId = useCurrentEntityId();
  const {
    data: plaidConnections,
    isLoading: bankAccountsLoading,
    isSuccess: banksAccountsLoaded,
  } = useGetEntityBanksQuery(
    {
      groupId: groupId!,
      entityId: entityId!,
      type: ACCOUNT_CONNECTION_TYPE.BANK_AND_CREDIT_CARD,
    },
    { skip: !groupId || !entityId }
  );

  const { totalAccounts, totalBalance, bankConnections } =
    useDataSourceSegregate(plaidConnections!);

  return (
    <Async.Root
      isSuccess={banksAccountsLoaded}
      isLoading={bankAccountsLoading}
      isEmpty={false}
    >
      <Async.Empty>
        <></>
      </Async.Empty>
      <Async.Success>
        <div className="t-overflow-y-auto t-py-3 t-px-2.5">
          {bankConnections.length > 0 ? (
            <>
              <AccountBanner
                totalBalance={totalBalance}
                totalAccounts={totalAccounts}
              />
              <AccountCardsSection>
                {bankConnections?.map((connection) => {
                  return (
                    <BankConnections
                      key={connection.uuid}
                      connection={connection}
                      onMigrationSuccess={onMigrationSuccess}
                    />
                  );
                })}
              </AccountCardsSection>
            </>
          ) : (
            <TabEmptyState
              title="No bank accounts or credit cards connected"
              description="Connect your bank accounts to start syncing & reconciling your transactions automatically"
              onOpenConnectionModal={onOpenConnectionModal}
              onOpenSubscriptionModal={onOpenSubscriptionModal}
            />
          )}
        </div>
      </Async.Success>
    </Async.Root>
  );
};
